import { defineStore } from 'pinia';

// Use base
import { BaseEstimateStore } from '@/stores/base/baseEstimateStore';

// Api
import reportCustomAPI from '@/apis/report/reportCustomAPI';
// store module
import { ModuleReportSummary } from '@/stores/moduleConst';

const reportSummaryStore = new BaseEstimateStore(reportCustomAPI);

// cần thêm gì thì dev tự thêm vào đây
const state = {
  _config: {},
  report: {},
};
const actions = {

};
const getters = {};

export const useReportSummaryStore = defineStore(ModuleReportSummary, {
  state: () => Object.assign(reportSummaryStore.state, state),
  actions: Object.assign(reportSummaryStore.action, actions),
  getters: Object.assign(reportSummaryStore.getters, getters),
});
